import {request} from './index.js'
import { oldPlatform } from './config.js';
// 获取统计数据
export async function salaryCount(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/salary/statistics/count`,
    data: {
      ...params
    }
  })
}
// 获取公司列表和部门列表
export async function mineInfo(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/mine/getMineCompanyInfo`,
    data: {
      ...params
    }
  })
}
// 获取当前公司和部门列表
export async function getAddressBook(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/office/getAddressBook`,
    data: {
      ...params
    }
  })
}
